'use client';

// import dynamic from 'next/dynamic';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast';
import { useToast } from '@/components/ui/use-toast';
import LottieAnimation from '../lottieAnimation/LottieAnimation';

// const LottieAnimation = dynamic(() => import('../lottieAnimation/LottieAnimation'), {
//   ssr: false,
// });

export function Toaster() {
  const { toasts } = useToast();
  return (
    <ToastProvider duration={6000}>
      {toasts.map(function ({ id, title, description, action, icon, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className='flex items-center justify-center gap-1 relative'>
              {icon && (
                <div className=''>
                  <LottieAnimation animationData={icon} height={80} width={80} loop={true} />
                </div>
              )}
              <div className={'-ml-2'}>
                {title && <ToastTitle className='text-lg'>{title}</ToastTitle>}
                {description && <ToastDescription>{description}</ToastDescription>}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
